function broadcast(componentName, eventName, params) {
  this.$children.forEach((child) => {
    const { name } = child.$options;

    if (name === componentName) {
      // eslint-disable-next-line
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}

function broadcastAll(eventName, params) {
  this.$children.forEach((child) => {
    const name = child.$options.name || '';

    if (name.indexOf('ten-') === 0 || name.indexOf('Ten') === 0) {
      // eslint-disable-next-line
      child.$emit.apply(child, [eventName].concat(params));
    }
    broadcastAll.apply(child, [eventName].concat(params));
  });
}

export default {
  methods: {
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let { name } = parent.$options;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          // eslint-disable-next-line
          name = parent.$options.name;
        }
      }
      if (parent) {
        // eslint-disable-next-line
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params);
    },
    broadcastAll,
  },
};
